import { render, staticRenderFns } from "./BankProduct.vue?vue&type=template&id=5ec5a2d8&scoped=true"
import script from "./BankProduct.vue?vue&type=script&lang=js"
export * from "./BankProduct.vue?vue&type=script&lang=js"
import style0 from "./BankProduct.vue?vue&type=style&index=0&id=5ec5a2d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5a2d8",
  null
  
)

export default component.exports